import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { aboutContent } from '@/mocks/about';

export default function AboutPage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.91n.con/' },
          { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.91n.con/about' },
        ],
      },
      {
        '@type': 'Organization',
        name: '91n.con 官方入口导航',
        url: 'https://www.91n.con',
        description: '提供91n.con最新可用地址、访问指引及常见问题解答的官方导航平台',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'support@91n.con',
          contactType: 'customer support',
        },
      },
      {
        '@type': 'AboutPage',
        name: '关于91n.con 官方入口导航',
        description: '了解91n.con官方入口导航的品牌故事、发展历程和用户口碑',
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <Navbar />
      <ScrollToTop />

      <div className="pt-16">
        <Breadcrumb items={[{ label: '关于我们' }]} />
      </div>

      <main>
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                {aboutContent.title}
              </h1>
              <p className="text-base text-foreground-500 max-w-2xl mx-auto">
                {aboutContent.subtitle}
              </p>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
                {aboutContent.brandStory.title}
              </h2>
              <div className="space-y-5">
                {aboutContent.brandStory.paragraphs.map((para, idx) => (
                  <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {para}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-10 text-center">
                发展历程
              </h2>
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-200/70 md:-translate-x-px"></div>
                <div className="space-y-8">
                  {aboutContent.timeline.map((item, idx) => (
                    <div
                      key={idx}
                      className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                        idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                      }`}
                    >
                      <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-right' : 'md:text-left'} pl-10 md:pl-0`}>
                        <div className="bg-background-100 rounded-xl p-5 border border-background-200/70">
                          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-2">
                            {item.year}
                          </span>
                          <p className="text-sm text-foreground-700 leading-relaxed">
                            {item.event}
                          </p>
                        </div>
                      </div>
                      <div className="hidden md:block flex-1"></div>
                      <div className="absolute left-0 md:left-1/2 top-6 w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50 -translate-x-1/2 shadow-sm">
                        <i className="ri-check-line text-sm"></i>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3 text-center">
                {aboutContent.reputation.title}
              </h2>
              <p className="text-sm text-foreground-500 text-center mb-10">
                来自真实用户的评价与反馈
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {aboutContent.reputation.items.map((item, idx) => (
                  <div
                    key={idx}
                    className="bg-background-50 rounded-xl p-6 border border-background-200/70"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <img
                        src={item.avatar}
                        alt={item.name}
                        className="w-12 h-12 rounded-full object-cover"
                      />
                      <div>
                        <h4 className="font-heading font-semibold text-foreground-900 text-sm">
                          {item.name}
                        </h4>
                        <span className="text-xs text-foreground-400">{item.role}</span>
                      </div>
                      <div className="ml-auto flex items-center gap-0.5">
                        {Array.from({ length: item.rating }).map((_, i) => (
                          <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                        ))}
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      &ldquo;{item.comment}&rdquo;
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3 text-center">
                {aboutContent.contactInfo.title}
              </h2>
              <p className="text-sm text-foreground-500 text-center mb-10">
                {aboutContent.contactInfo.description}
              </p>

              <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                  <div className="text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                      <i className="ri-mail-line text-xl"></i>
                    </div>
                    <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-1">
                      电子邮件
                    </h4>
                    <span className="text-sm text-foreground-500">{aboutContent.contactInfo.email}</span>
                  </div>
                  <div className="text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                      <i className="ri-time-line text-xl"></i>
                    </div>
                    <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-1">
                      响应时间
                    </h4>
                    <span className="text-sm text-foreground-500">{aboutContent.contactInfo.responseTime}</span>
                  </div>
                  <div className="text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600">
                      <i className="ri-shield-check-line text-xl"></i>
                    </div>
                    <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-1">
                      安全保障
                    </h4>
                    <span className="text-sm text-foreground-500">官方认证平台</span>
                  </div>
                </div>

                <div className="mt-6 p-4 bg-accent-50 border border-accent-200/70 rounded-lg">
                  <p className="text-xs text-foreground-600 leading-relaxed text-center">
                    <strong className="text-foreground-900">安全提醒：</strong>
                    {aboutContent.contactInfo.tips}
                  </p>
                </div>
              </div>

              <div className="mt-10 text-center">
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-home-4-line"></i>
                  返回首页获取最新地址
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}